//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../Die/Die.PierceItemBuilderList.js";
import "../Features/Features.SelectFeature.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[1,"AssociatedObjects",0,"SelectNXObjectList",0],[0,"CamDirection",1,"ILocation",0],[0,"CamType",1,0],[0,"CenterPointOption",1,0],[0,"CreateScrap",1,0],[0,"DistanceTolerance",1,0],[0,"FinishOperation",1,0],[0,"LayoutFlange",1,0],[1,"PierceHoles",0,"ScCollector",0],[1,"PierceHolesList",0,"Die.PierceItemBuilderList",0],[0,"PrecisionType",1,0],[1,"TipFeature",0,"Features.SelectFeature",0],[0,"TippedProduct",1,"Features.Feature",0],[0,"TrimNewDieFace",1,0],[0,"WithoutWorkflowSheet",1,"Body",0]],[[["direction","profile_entries"],"SetPierceBounds",{},2,0],[["direction","num_profile_entries"],"GetPierceBounds",{R_:{profile_entries:"IProfile[]"}},0,0],[["objects"],"SetAssociativeObjects",{},1,0],[["num_objects"],"GetAssociativeObjects",{R_:{objects:"DisplayableObject[]"}},0,0],[["objects"],"SetCameraViews",{},1,0],[["num_objects"],"GetCameraViews",{R_:{objects:"View[]"}},0,0],[["strings"],"SetDetails",{},1,0],[["num_strings"],"GetDetails",{R_:{strings:""}},0,0],[["num_objects","xmlp_data"],"GetCameraLayerAndXmlp",{R_:{layer_settings:""}},0,0],[["layer_settings","xmlp_data"],"SetCameraLayerAndXmlp",{},2,0],[["strings"],"SetCameraNames",{},1,0],[["num_strings"],"GetCameraNames",{R_:{strings:""}},0,0],[["hole_shape"],"NewPierceHole",{R_:{pierceHole:"Die.PierceItemBuilder"}},1,0]],[]];
SPLM.Die.PierceTaskBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.PierceTaskBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.PierceTaskBuilder.CamTypes = Object.freeze({
    "Direct" : "Direct", "Aerial" : "Aerial", "BaseMounted" : "BaseMounted"});

SPLM.Die.PierceTaskBuilder.PrecisionTypes = Object.freeze({
    "Gage" : "Gage", "Critical" : "Critical", "Standard" : "Standard"});

SPLM.Die.PierceTaskBuilder.CenterPointOptionTypes = Object.freeze({
    "None" : "None", "Die" : "Die", "Product" : "Product", "Both" : "Both"});

export default SPLM;